var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('UiTabs',[_c('UiTab',{attrs:{"to":"/overview"}},[_vm._v("Production")]),_c('UiTab',{attrs:{"to":"/overview/payment"}},[_vm._v("Payment")]),_c('UiTab',{attrs:{"to":"/overview/base"}},[_vm._v("Base")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }